const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.042 1.41602H15.0524C15.3458 1.41602 15.5837 1.65386 15.5837 1.94727V4.95768C15.5837 5.25108 15.3458 5.48893 15.0524 5.48893C14.759 5.48893 14.5212 5.25108 14.5212 4.95768V3.19393L10.6253 7.08268C10.5356 7.20097 10.3982 7.27356 10.2499 7.28102C10.1089 7.28168 9.97358 7.22551 9.87449 7.12518C9.66734 6.91777 9.66734 6.58176 9.87449 6.37435L13.7562 2.47852H12.042C11.7486 2.47852 11.5107 2.24067 11.5107 1.94727C11.5107 1.65386 11.7486 1.41602 12.042 1.41602ZM14.5212 14.3431V8.27977C14.5212 7.98636 14.2833 7.74852 13.9899 7.74852C13.6965 7.74852 13.4587 7.98636 13.4587 8.27977V14.3431C13.4587 14.4409 13.3794 14.5202 13.2816 14.5202H2.65658C2.55878 14.5202 2.47949 14.4409 2.47949 14.3431V3.7181C2.47949 3.6203 2.55878 3.54102 2.65658 3.54102H8.74116C9.03456 3.54102 9.27241 3.30317 9.27241 3.00977C9.27241 2.71636 9.03456 2.47852 8.74116 2.47852H2.65658C1.97358 2.48239 1.42086 3.03511 1.41699 3.7181V14.3431C1.42086 15.0261 1.97358 15.5788 2.65658 15.5827H13.2816C13.9646 15.5788 14.5173 15.0261 14.5212 14.3431Z",
  fill: "#00BEFF"
});

const SvgRedirect = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRedirect, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/redirect.4ecbb1b4.svg";
export { ForwardRef as ReactComponent };